import { Theme, Components } from '@mui/material/styles';

const HEIGHT_SM = 34;
const HEIGHT_MD = 44;

export const MuiPickersTextField: Components<Theme>['MuiPickersTextField'] = {
  styleOverrides: {
    root: ({ theme, size }) => {
      const isSmall = size === 'small';

      // Typography follows the type scale: medium === body1, small === body2.
      // Mirrors MuiOutlinedInput so the picker input matches TextField.
      const typeScale = isSmall
        ? theme.typography.body2
        : theme.typography.body1;

      return {
        '& .MuiPickersInputBase-root': {
          ...typeScale,
          height: isSmall ? HEIGHT_SM : HEIGHT_MD,

          // Disabled
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[100],
            input: { WebkitTextFillColor: theme.palette.text.primary },
            fieldset: { border: 'none' },
          },
        },
      };
    },
  },
};
